const fetchFilterData = (course, state, city, date) => async dispatch => {
  dispatch({
    type: "FILTER",
    payload: { course: course, state: state, city: city, date: date }
  });
};


export default fetchFilterData;
